import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    loading: false,
    error: null,
    notifications: []
  },
  reducers: {
    // Existing reducers
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    
    // New notification reducers
    addNotification: (state, action) => {
      const id = Date.now().toString();
      state.notifications.push({
        id,
        ...action.payload,
        // Set default type if not provided
        type: action.payload.type || 'info'
      });
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        notification => notification.id !== action.payload
      );
    },
    clearNotifications: (state) => {
      state.notifications = [];
    }
  }
});

export const { 
  setLoading, 
  setError, 
  addNotification, 
  removeNotification,
  clearNotifications 
} = uiSlice.actions;

export default uiSlice.reducer;